<template>
    <div class="warn_row_box">
       <div class="row_item">
          <span>告警设备：</span>
          <span>{{ row.devName }}</span>
       </div>
       <div class="row_item">
          <span>告警时间：</span>
          <span>{{ row.alarmTime }}</span>
       </div>
       <div class="row_item">
          <span>告警内容：</span>
          <span>{{ row.alarmContent }}</span>
       </div>
    </div>
</template>

<script>
    export default {
        props:{
            row:Object
        }
    }
</script>

<style lang="scss" scoped>
.warn_row_box{
    color: #fff;
    .row_item{
        display: flex;
        span:first-child{
           flex-shrink: 0;
        }
    }
    .row_item:not(:last-child){
        margin-bottom: 5px;
    }
}
</style>